var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Container",on:{"click":function($event){$event.preventDefault();return _vm.handleClick.apply(null, arguments)}}},[_c('img',{attrs:{"src":require("@/assets/Downloaded.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }